import './Overview.scss';
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../context";
import {groupFromPage} from "../../helper";
import SVG from "react-inlinesvg";

export function ResultHeaderOverview() {
    const {responseArray, pages} = useContext(GlobalContext);
    const [groupedResponses, setGroupedResponses] = useState([]);

    console.log('ResultHeaderOverview', {responseArray, pages});

    useEffect(() => {
        const grouped = responseArray.reduce((acc, response) => {
            const page = pages.find(page => page.key === response.key);
            let group = acc.find(group => group.name === page.groupName);
            if (!group) {
                group = groupFromPage(page);
                acc.push(group);
            }
            const values = Array.isArray(response.value) ? response.value : [response.value];
            const answerLabels = values.map(value => page.answers.find(answer => answer.value === value)?.label);
            group.entries.push(...answerLabels);
            console.log('ResultHeaderOverview - reduce', {response, page, group, values, answerLabels});
            return acc;
        }, []);
        grouped.forEach(group => {
            group.joinedText = group.entries.join(', ');
        });
        grouped.sort((a, b) => a.order - b.order);
        setGroupedResponses(grouped);
    }, [responseArray, setGroupedResponses]);

    console.log('ResultHeaderOverview - render', {groupedResponses});
    return (
        <div className="rh-overview d-flex flex-row flex-wrap flex-shrink-1">
            {groupedResponses.map((group) => (
                <div key={group.name} className="rho-group d-flex flex-row flex-wrap flex-nowrap align-items-center mb-1">
                    <SVG
                        src={group.icon}
                        width="12"
                        height="12"
                    />
                    <div>{group.joinedText}</div>
                </div>
            ))}
        </div>
    );
}